import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=03ffb6fc&scoped=true&"
import script from "./TodoList.vue?vue&type=script&lang=js&"
export * from "./TodoList.vue?vue&type=script&lang=js&"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=03ffb6fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ffb6fc",
  null
  
)

export default component.exports